import React from 'react';

class Spinner extends React.Component {

  className() {
    let result = 'spinner-border';
    if (this.props.className) {
      result += ' ' + this.props.className;
    }
    return result;
  }

  style() {
    const result = {};
    if (this.props.sizeInPx) {
      result.width = this.props.sizeInPx + 'px';
      result.height = result.width;
    }
    return result;
  }

  render() {
    return <div className={this.className()} style={this.style()} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>;
  }

}

export default Spinner;
